// pages/QuestionnairePill.tsx
import QuestionnaireForm from '../components/QuestionnaireForm';
const QuestionnairePill = () => (
  <QuestionnaireForm questionFile="pill_questions.json" service="pill" />
);
export default QuestionnairePill;
